import React, { useState, useEffect, useCallback, useRef  } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Save, FileText, Film, LogOut } from "react-feather";


const AddMoreCategory = ({onCategoryChange}) => {
  
    const [loading, setLoading] = useState(false);
 
   const [menus, setMenus] = useState([]);
     const [mainCategories, setMainCategories] = useState([]);
     const [subCategories, setSubCategories] = useState([]);
     const [subSubCategories, setSubSubCategories] = useState([]);
     const [subSubSubCategories, setSubSubSubCategories] = useState([]);
     const [finalCategories, setFinalCategories] = useState([]);
     const [sixCategories, setSixCategories] = useState([]);
     const [seventhCategories, setSeventhCategories] = useState([]);
     const [eightCategories, setEightCategories] = useState([]);
     const [nineCategories, setNineCategories] = useState([]);
   
   
     const [selectedMainCategory, setSelectedMainCategory] = useState("");
     const [selectedSubCategory, setSelectedSubCategory] = useState("");
     const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
     const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
     const [selectedFinalCategory, setSelectedFinalCategory] = useState("");
     const [selectedSixCategory, setSelectedSixCategory] = useState("");
     const [selectedSeventhCategory, setSelectedSeventhCategory] = useState("");
     const [selectedEightCategory, setSelectedEightCategory] = useState("");
     const [selectedNineCategory, setSelectedNineCategory] = useState("");
   
     const [categories, setCategories] = useState([]);
   
   
   
   
   // Fetch Menus
   useEffect(() => {
     axios
       .get(`${baseurl}getMenus`)
       .then((response) => {
         setMenus(response.data);
         setMainCategories(response.data.filter(menu => menu.parent_id === null));
       })
       .catch((error) => console.error("Error fetching menus:", error));
   }, []);
   
   // Handle dropdown changes
   const handleMainCategoryChange = (e) => {
     const selectedId = parseInt(e.target.value);
     setSelectedMainCategory(selectedId);
     setSubCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset all lower-level categories
     setSelectedSubCategory("");
     setSubSubCategories([]);
     setSelectedSubSubCategory("");
     setSubSubSubCategories([]);
     setSelectedSubSubSubCategory("");
     setFinalCategories([]);
     setSelectedFinalCategory("");
     setSixCategories([]);
     setSelectedSixCategory("");
     setSeventhCategories([]);
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleSubCategoryChange = (e) => {
     const selectedId = parseInt(e.target.value);
     setSelectedSubCategory(selectedId);
     setSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset lower categories
     setSelectedSubSubCategory("");
     setSubSubSubCategories([]);
     setSelectedSubSubSubCategory("");
     setFinalCategories([]);
     setSelectedFinalCategory("");
     setSixCategories([]);
     setSelectedSixCategory("");
     setSeventhCategories([]);
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleSubSubCategoryChange = (e) => {
   
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
   
   
   
     const selectedId = parseInt(e.target.value);
     setSelectedSubSubCategory(selectedId);
     setSubSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset lower categories
     setSelectedSubSubSubCategory("");
     setFinalCategories([]);
     setSelectedFinalCategory("");
     setSixCategories([]);
     setSelectedSixCategory("");
     setSeventhCategories([]);
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleSubSubSubCategoryChange = (e) => {
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
   
   
     const selectedId = parseInt(e.target.value);
     setSelectedSubSubSubCategory(selectedId);
     setFinalCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset lower categories
     setSelectedFinalCategory("");
     setSixCategories([]);
     setSelectedSixCategory("");
     setSeventhCategories([]);
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleFinalCategoryChange = (e) => {
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
   
   
     const selectedId = parseInt(e.target.value);
     setSelectedFinalCategory(selectedId);
     setSixCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset 6th, 7th, 8th, and 9th level categories
     setSelectedSixCategory("");
     setSeventhCategories([]);
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleSixCategoryChange = (e) => {
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
   
   
   
     const selectedId = parseInt(e.target.value);
     setSelectedSixCategory(selectedId);
     setSeventhCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset 7th, 8th, and 9th level categories
     setSelectedSeventhCategory("");
     setEightCategories([]);
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleSeventhCategoryChange = (e) => {
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
   
     const selectedId = parseInt(e.target.value);
     setSelectedSeventhCategory(selectedId);
     setEightCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset 8th and 9th level categories
     setSelectedEightCategory("");
     setNineCategories([]);
     setSelectedNineCategory("");
   };
   
   const handleEightCategoryChange = (e) => {
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
     const selectedId = parseInt(e.target.value);
     setSelectedEightCategory(selectedId);
     setNineCategories(menus.filter(menu => menu.parent_id === selectedId));
   
     // Reset 9th level category
     setSelectedNineCategory("");
   };
   
   const handleNineCategoryChange = (e) => {
   
     const selectedCategoryId = parseInt(e.target.value);
     setCategories(selectedCategoryId);
    
     handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
     setSelectedNineCategory(selectedId);
   };
   
   const handleCategoryChange = (selectedOption) => {
    onCategoryChange(selectedOption ? selectedOption.value : ""); // Pass only the ID
  };
  

  return (
    <>
         
<div className="row g-2 bg-white pb-3">
     {/* Main Category */}
     <div className="col-md-4">
                <label className="form-label">Item Category<span className="text-danger">*</span></label>
                <select className="form-select" value={selectedMainCategory} onChange={handleMainCategoryChange} required>
                  <option value="">Select Main Category</option>
                  {mainCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                </select>
              </div>

              {/* Other dropdowns (Sub Categories) */}
              {subCategories.length > 0 && (
                <div className="col-md-4">
                  <label className="form-label">Sub Category<span className="text-danger">*</span></label>
                  <select className="form-select" value={selectedSubCategory} onChange={handleSubCategoryChange} required>
                    <option value="">Select Sub Category</option>
                    {subCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                  </select>
                </div>
              )}

 {/* Sub-Sub Category */}
      {subSubCategories.length > 0 && (
        <div className="col-md-4">
          <label className="form-label">Make/Brand<span className="text-danger">*</span></label>
          <select className="form-select" value={selectedSubSubCategory} onChange={handleSubSubCategoryChange} required>
            <option value="">Select Sub-Sub Category</option>
            {subSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      {/* Sub-Sub-Sub Category */}
      {subSubSubCategories.length > 0 && (
        <div className="col-md-4">
          <label className="form-label">Instrument Type<span className="text-danger">*</span></label>
          <select className="form-select" value={selectedSubSubSubCategory} onChange={handleSubSubSubCategoryChange} required>
            <option value="">Select Instrument Type</option>
            {subSubSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}


{finalCategories.length > 0 && (
        <div className="col-md-4">
          <label className="form-label">Modal Number<span className="text-danger">*</span></label>
          <select 
          className="form-select"
          id="listingCategoryTwo"
          name="listingCategoryTwo"
          
          value={selectedFinalCategory} onChange={handleFinalCategoryChange} required>
            <option value="">Select Final Category</option>
            {finalCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}
 

{/* 6th Level Category */}
{sixCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">6th Level Category</label>
  <select className="form-select" value={selectedSixCategory} onChange={handleSixCategoryChange}>
    <option value="">Select 6th Level Category</option>
    {sixCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}


{/* 7th Level Category */}
{seventhCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">7th Level Category</label>
  <select className="form-select" value={selectedSeventhCategory} onChange={handleSeventhCategoryChange}>
    <option value="">Select 7th Level Category</option>
    {seventhCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}


{/* 8th Level Category */}
{eightCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">8th Level Category</label>
  <select className="form-select" value={selectedEightCategory} onChange={handleEightCategoryChange}>
    <option value="">Select 8th Level Category</option>
    {eightCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}


{/* 9th Level Category */}

{nineCategories.length > 0 && (

<div className="col-md-4">
  <label className="form-label">9th Level Category</label>
  <select className="form-select" value={selectedNineCategory} onChange={handleNineCategoryChange}>
    <option value="">Select 9th Level Category</option>
    {nineCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}


</div>

    </>
  );
};

export default AddMoreCategory;
